import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDynamicInner]'
})
export class DynamicInnerDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
